
import { Box, Button, Typography } from "@mui/material";
import React from "react";
import {
  blackShade05,
  blueColor02,
  blueColor04,
  greyColor24,
  mobilePrimary,
  redColorBG01,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";

function MobileEasyCartEmptyCard({ onClick }) {
  return (
    <Box sx={styles.card}>
      <Box sx={styles.iconContainer}>
        <Box
          component="img"
          src={
            "https://storage.googleapis.com/bodefaults/businessdashboardweb/easy-empty.svg"
          }
          width="40px"
        />
      </Box>

      <Typography
        color={blackShade05}
        fontSize={14}
        fontWeight={500}
        textAlign={"center"}
        lineHeight={1.5}
        mt={1}
      >
        {`Maximize Your Order Volume: Enable One-Click Payment Carts for Your Customers!`}
      </Typography>
      <Box display={"flex"} gap={1}>
        <Typography
          fontSize={14}
          fontWeight={500}
          lineHeight={1.8}
          sx={{
            color: { xs: mobilePrimary, md: blueColor04 },
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={onClick}
        >
          Click here
        </Typography>
        <Typography
          color={blackShade05}
          fontSize={15}
          fontWeight={500}
          lineHeight={1.5}
          sx={{ textDecoration: "none" }}
        >
          to get started.
        </Typography>
      </Box>
    </Box>
  );
}

export default MobileEasyCartEmptyCard;

const styles = {
  card: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    background: redColorBG01,
    marginBottom: "12px",
    borderRadius: "10px",
    padding: "20px 0 0 0",
    textAlign: "center",
  },
  iconContainer: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    background: whiteColor,
    mb: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  actionBtn: {
    fontSize: "13px",
    fontWeight: "600",
    color: { xs: mobilePrimary, md: blueColor04 },
    backgroundColor: whiteColor,
    padding: "3px 22px",
    mt: "12px",
    border: {
      xs: `1px solid ${mobilePrimary}`,
      md: `1px solid ${blueColor04}`,
    },
    "&:hover": {
      color: whiteColor,
      backgroundColor: { xs: mobilePrimary, md: blueColor04 },
    },
  },
};
